import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FileService } from 'src/app/services/file.service';
import { OrderService } from 'src/app/services/order.service';
import { saveAs } from 'file-saver';
import { CommonService } from 'src/app/services/common.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpResponse } from '@angular/common/http';
interface InvoiceData {
  "id": string,
  "invoiceDate": string,
  "paymentDueDate": string,
  "orderNo": string,
  "invoiceNo": string,
  "invoiceType": string,
  "customerId": string,
  "invoiceStatus": string,
  "totalAmount": string,
  "netValue": string,
  "taxAmount": string,
  "currency": string,
  "paymentCondition": string,
  "deliveries": string,
  "customerName": string,
  "poNo": string
}

@Component({
  selector: 'invoice-data',
  templateUrl: './invoice-data.component.html',
  styleUrls: ['./invoice-data.component.less']
})
export class InvoiceDataComponent implements OnInit {

  searchFormData!: FormGroup;
  financialListData: InvoiceData[] = [];
  codeTypeList: any = [];
  typeList: any = [];
  statusList: any = [];
  sortList: any = [
  ];
  pagination = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    pageSizeOptions: [10, 20, 50],
  };
  isSpinning = true;
  constructor(
    private fb: FormBuilder,
    private orderService: OrderService,
    private fileService: FileService,
    private commonService: CommonService,
    private router: Router,
    private translate: TranslateService
  ) { }
  // 初始化
  ngOnInit(): void {
    this.updateData();
    this.translate.onLangChange.subscribe(() => {
      this.updateData();
    });
    this.searchFormData = this.fb.group({
      paymentDueDate: [[], []],
      issueDate: [[], []],
      invoiceStatus: ['', []],
      invoiceType: ['', []],
      keywordsType: ['invoiceNo', []],
      keywords: ['', []],
      sortType: ['iv.invoice_date/desc', []],
    });
    this.getList();
  }

  updateData(): void {
    this.sortList = [
      { name: this.translate.instant('INVOICE_DATE_DESC'), value: 'iv.invoice_date/desc' },
      { name: this.translate.instant('INVOICE_DATE_ASC'), value: 'iv.invoice_date/asc' },
      { name: this.translate.instant('INVOICE_NO_ASC'), value: 'iv.invoice_no/asc' },
      { name: this.translate.instant('INVOICE_NO_DESC'), value: 'iv.invoice_no/desc' },
      { name: this.translate.instant('ORDER_DESC'), value: 'iv.order_no/desc' },
      { name: this.translate.instant('ORDER_ASC'), value: 'iv.order_no/asc' },
    ];
    this.codeTypeList = [
      { name: this.translate.instant('BY_INVOICE_NUMBER'), value: 'invoiceNo' },
      { name: this.translate.instant('BY_CUSTOMER_ORDER_NO'), value: 'poNo' },
      { name: this.translate.instant('BY_ORDER_NO'), value: 'orderNo' },
    ];
    this.statusList = [
      { name: this.translate.instant('ALL_STATUS'), value: '' },
      { name: this.translate.instant('PAID'), value: 'Paid' },
      { name: this.translate.instant('OPEN'), value: 'Open' },
      { name: this.translate.instant('OVERDUE'), value: 'Overdue' },
    ];
    this.typeList = [
      { name: this.translate.instant('ALL_TYPE'), value: '' },
      { name: this.translate.instant('INVOICE'), value: 'invoice' },
      { name: this.translate.instant('CREDIT_NOTE'), value: 'credit' },
      { name: this.translate.instant('DEBIT_NOTE'), value: 'debit' },
    ];
  }
  changeKeywords() {
    this.searchFormData.get('keywords')?.setValue('');
  }
  getColorByStatus(status: string, isBackground: boolean, isBorder: boolean): string {
    let color = "";
    switch (status) {
      case "Overdue":
        color = isBackground ? "#ED0007" : (isBorder ? "#ED0007" : "#ED0007");
        break;
      case "Open":
        color = isBackground ? "#F9F2F9" : (isBorder ? "#C279BE" : "#9E2896");
        break;
      case "Paid":
        color = isBackground ? "#DEF5F3" : (isBorder ? "#84BDBA" : "#18837E");
        break;
      default:
        color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
        break;
    }
    return color;
  }
  getList() {
    this.isSpinning = true;
    const dynamicObject: { [key: string]: string } = {
      [this.searchFormData.value.keywordsType]:
        this.searchFormData.value.keywords,
    };
    const [sortType, ascType] = this.searchFormData.value.sortType.split('/');
    let params = {
      ...dynamicObject,
      size: this.pagination.pageSize,
      current: this.pagination.pageIndex,
      paymentDueDateEnd: this.searchFormData.value.paymentDueDate
        ? this.commonService.formatDateString(this.searchFormData.value.paymentDueDate[1]) ?? ''
        : '',
      paymentDueDateStart: this.searchFormData.value.paymentDueDate
        ? this.commonService.formatDateString(this.searchFormData.value.paymentDueDate[0]) ?? ''
        : '',
      invoiceDateEnd: this.searchFormData.value.issueDate
        ? this.commonService.formatDateString(this.searchFormData.value.issueDate[1]) ?? ''
        : '',
      invoiceDateStart: this.searchFormData.value.issueDate
        ? this.commonService.formatDateString(this.searchFormData.value.issueDate[0]) ?? ''
        : '',
      invoiceStatus: this.searchFormData.value.invoiceStatus,
      invoiceType: this.searchFormData.value.invoiceType,
      column: sortType,
      order: ascType
    };
    this.orderService.queryInvoiceData(params).subscribe((result: any) => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        const { total, rows } = rtnData
        this.financialListData = rows;
        this.pagination.total = total;
      }
      this.isSpinning = false;
    });
  }
  //export
  exportExcel(): void {
    this.fileService
      .exportToExcel(
        `/eshop_backend/invoice/export?size=${this.pagination.pageSize}&current=${this.pagination.pageIndex}&invoiceDateEnd=${this.searchFormData.value.issueDate
          ? this.commonService.formatDateString(this.searchFormData.value.issueDate[1]) ?? ''
          : ''}&paymentDueDateEnd=${this.searchFormData.value.paymentDueDate
            ? this.commonService.formatDateString(this.searchFormData.value.paymentDueDate[1]) ?? ''
            : ''
        }&paymentDueDateStart=${this.searchFormData.value.paymentDueDate
          ? this.commonService.formatDateString(this.searchFormData.value.paymentDueDate[0]) ?? ''
          : ''
        }&invoiceDateStart=${this.searchFormData.value.issueDate
          ? this.commonService.formatDateString(this.searchFormData.value.issueDate[0]) ?? ''
          : ''}&invoiceType=${this.searchFormData.value.invoiceType}&invoiceStatus=${this.searchFormData.value.invoiceStatus}&${this.searchFormData.value.keywordsType}=${this.searchFormData.value.keywords}`
      )
      .subscribe(
        (response: HttpResponse<Blob>) => {
          const contentDisposition = response.headers.get('Content-Disposition');
          let fileName = `invoice.xlsx`;
          if (contentDisposition) {
            fileName = contentDisposition.split('fileName=')[1]?.split(';')[0]?.replace(/"/g, '');
          }
          const blob = new Blob([response.body!], {
            type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          saveAs(blob, fileName);
        },
        (error: any) => {
          console.error('Error exporting Excel:', error);
        }
      );
  }
  handleChange(e: Event): void {
    this.pagination.pageIndex = 1;
    this.getList();
  }
  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
    this.pagination.pageIndex = 1;
    this.getList();
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.getList();
  }
  onInputEnter(event: any): void {
    event.preventDefault();
    this.getList();
  }
  goPage(url: string, data: any): void {
    const country = localStorage.getItem("country");
    this.router.navigate([`${country}/${url}`], { queryParams: { orderNo: data } });
  }

}
